import config from "config/config"
import axios from "axios"

import * as url from "../helpers/url_helper"

export const categoryApi = {
  addSubjectWiseCategory: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.Subject_Category_Add_Update}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }

    return await axios(axiosConfig)
  },

  addSubjectPlusTopicWiseCategory: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.Subject_Plus_Topic_Category_Add_Update}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }

    return await axios(axiosConfig)
  },

  getAllCategory: async (page = 1, sessionId = null) => {
    const params = new URLSearchParams({ page })
    if (sessionId) params.append("session_id", sessionId)
    var axiosConfig = {
      method: "GET",
      url: `${config.API_URL}${url.All_Category_Get}?${params.toString()}`,
      headers: {
        "Content-Type": "application/json",
      },
    }
    return await axios(axiosConfig)
  },

  deleteCategory: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.Category_Delete}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }
    return await axios(axiosConfig)
  },
}
